import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../actions'
import { IPaymentsState } from '../types'

const initialState: IPaymentsState['data'] = {
  deposit: {
    createdDeposit: null,
    screenshotsData: null,
    systemList: {
      page: 1,
      count: 0,
      list: [],
    },
  },
  payout: {
    systemList: {
      page: 1,
      count: 0,
      list: [],
    },
  },
  convertedAmountData: null,
  cryptoCurrenciesList: [],
  cryptoMinAmountByCurrency: null,
  cashiersList: [],
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getDepositSystemList.success, (state, action) => {
      state.deposit.systemList = action.payload
    })
    .addCase(actions.clearDepositCreated, state => {
      state.deposit.createdDeposit = null
    })
    .addCase(actions.createDeposit.success, (state, action) => {
      state.deposit.createdDeposit = action.payload
    })
    .addCase(actions.getCryptoCurrenciesList.success, (state, action) => {
      state.cryptoCurrenciesList = action.payload
    })
    .addCase(actions.getCryptoMinAmount.success, (state, action) => {
      state.cryptoMinAmountByCurrency = {
        ...(state.cryptoMinAmountByCurrency ?? {}),
        [action.payload.currency]: action.payload,
      }
    })
    .addCase(actions.getPayoutSystemList.success, (state, action) => {
      state.payout.systemList = action.payload
    })
    .addCase(actions.clearConvertedAmountData, state => {
      state.convertedAmountData = null
    })
    .addCase(actions.getCryptoEstimateAmount.success, (state, action) => {
      state.convertedAmountData = action.payload
    })
    .addCase(actions.getCashiersList.success, (state, action) => {
      state.cashiersList = action.payload
    })
    .addCase(actions.clearScreenshotsData, state => {
      state.deposit.screenshotsData = null
    })
    .addCase(actions.addScreenshotsData, (state, action) => {
      state.deposit.screenshotsData = action.payload.data
    })
})
